import React from 'react';
import {useEventContext} from 'providers/EventProvider';
import {useSplitContext} from 'providers/SplitProvider';
import {Box, Typography, Stack, Paper} from '@mui/material';
import {styled} from '@mui/material/styles';

const convertTime = (time: number) => {
  const min = Math.floor(time / 60);
  const sec = time % 60;
  return `${min}:${sec < 10 ? '0' : ''}${sec}`;
};

interface SplitTimesProps {
  all: boolean;
}

const PlayerItem = styled(Paper)(({theme}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: 0,
  borderBottom: '1px solid rgba(0,0,0,0.1)',
  '&:last-child': {
    borderBottom: 'none'
  }
}));

const SplitTimes: React.FC<SplitTimesProps> = (props) => {
  const {visiblePlayers} = useEventContext();
  const {activeSplits} = useSplitContext();

  if (activeSplits.length === 0) return null;

  return (
    <Box>
      <Box
        sx={{
          borderBottom: '1px solid rgba(0,0,0,0.4)',
          px: 0.5,
          color: '#ff0060',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Typography variant="subtitle1" sx={{color: '#ff0060', fontWeight: 'bold'}}>
          Times
        </Typography>
      </Box>
      {activeSplits.length > 0 && (
        <Stack spacing={0} px={0.5}>
          {visiblePlayers.map((player, i) => (
            <PlayerItem key={i} elevation={0}>
              <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                <Typography
                  variant="body1"
                  sx={{
                    color: player.display.color || player.color,
                    fontWeight: 'medium',
                    minWidth: '60px',
                    textAlign: 'left'
                  }}
                >
                  {player.name}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{minWidth: '40px'}}>
                  {player.distance}m
                </Typography>
              </Box>
              <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                <Typography
                  variant="body1"
                  sx={{
                    color: player.display.color || player.color,
                    fontWeight: 'medium',
                    minWidth: '60px',
                    textAlign: 'right'
                  }}
                >
                  {convertTime(player.time)}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{minWidth: '40px'}}>
                  +{convertTime(player.diff)}
                </Typography>
              </Box>
            </PlayerItem>
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default SplitTimes;
